import { FC } from 'react';
import { SvgIcon } from 'src/components/common/SvgIcon';
import { Typography } from 'src/components/common/Typography';
import { MediaManager } from 'src/manager/MediaManager';
import '../styles.scss';

type Props = {
  t: (arg: string) => string;
};
const ViewWithoutResult: FC<Props> = ({ t }) => (
  <div className="wrapper">
    <Typography className="subTitle" variant={'h6'}>
      {t('searchDefaultText')}
    </Typography>
    <div className="result_search_icon">
      <SvgIcon src={MediaManager.getSrcFromMediaAssets('content_search.svg', '/icons/svg/')} />
    </div>
  </div>
);
export default ViewWithoutResult;
